import React, { Component } from 'react';
import objectFitImages from 'object-fit-images';

// components
import Filter from '../../../components/Filter';
import RenderOverview from './RenderOverview';
import CaseInProgress from './CaseInProgress';

export default class Overview extends Component {
    state = {
        selectedOption: null,
        active: false,
    };

    handleChangeSelect = selectedOption => {
        this.setState({ selectedOption, active: true });
    };

    componentDidMount() {
        objectFitImages();
    }

    renderFilter() {
        if (!!this.props.work && this.props.work.length > 0) {
            const { work } = this.props;

            let categories = work.map(
                value => value.pure_taxonomies.types[0].name
            );

            // Remove array duplications from categories array
            // https://medium.com/dailyjs/how-to-remove-array-duplicates-in-es6-5daa8789641c
            let uniqueCategories = new Set(categories);
            let cleanupArray = [...uniqueCategories];

            // transform cleanupArray in usefull react-select data-object
            let workCategories = cleanupArray.map(element => {
                return {
                    value: element,
                    label: element.replace(/&amp;/g, '&'),
                };
            });

            return (
                <Filter
                    options={workCategories}
                    onChange={this.handleChangeSelect}
                />
            );
        }
    }

    renderPosts() {
        if (!!this.props.work && this.props.work.length > 0) {
            const { work } = this.props;
            const { selectedOption, active } = this.state;

            return (
                <div>
                    <RenderOverview
                        work={
                            selectedOption
                                ? work.filter(
                                      value =>
                                          value.pure_taxonomies.types[0]
                                              .name === selectedOption.value
                                  )
                                : work
                        }
                        active={active}
                    />
                </div>
            );
        }
    }

    renderCaseInProgress() {
        if (!!this.props.work && this.props.work.length > 0) {
            return <CaseInProgress />;
        }
    }

    render() {
        return (
            <div id="overview">
                <header className="intro-header">
                    <h1>We’re quite proud of our CASES</h1>
                </header>
                {this.props.pathname !== '/archive' &&
                    this.props.pathname !== '/archive/' &&
                    this.renderFilter()}
                {this.renderPosts()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/WorkOverview/Overview.js